module.exports = "/work-site/img/banner.48b44a99.png";